import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withRouter } from 'react-router-dom';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty, isNil } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';

import Atlas from '../../../api/Atlas/Atlas';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import Loading from '../../components/LoadingIpsilum';
import LoadingFree from '../../components/LoadingIpsilumFree';
import TableList from '../../components/TableList';

const PER_PAGE = 15;

class AtlasList extends Component {
  state = {
    isTrashOpen: false
  };

  closeTrash = () => this.setState({ isTrashOpen: false });

  handleDuplicate = async atlasId => {
    try {
      await methodPromise('atlas.copy', atlasId);
      Bert.alert('Atlas Duplicated!', 'info');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleHardRemove = async atlasId => {
    try {
      await methodPromise('atlas.hardDelete', atlasId);
      Bert.alert('Atlas deleted!', 'danger');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleRestore = async atlasId => {
    try {
      await methodPromise('atlas.restore', atlasId);
      Bert.alert('Atlas Restored!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleSoftRemove = async atlasId => {
    try {
      await methodPromise('atlas.softDelete', atlasId);
      Bert.alert('Atlas moved to Trash!', 'warning');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  openTrash = () => this.setState({ isTrashOpen: true });

  render() {
    const {
      atlasList,
      changePage,
      currentPage,
      deletedAtlas,
      deletedCount,
      handleSearch,
      handleSort,
      history,
      isAdmin,
      isBasic,
      isPremium,
      loading,
      match,
      searching,
      sort,
      totalCount,
      unfilteredCount
    } = this.props;
    const { isTrashOpen } = this.state;
    const tableHeaders = [
      {
        count: totalCount,
        filteredCount: unfilteredCount === totalCount ? '' : unfilteredCount - totalCount,
        name: 'Atlas',
        sortValue: 'name'
      },
      {
        isHiddenOnXS: true,
        name: 'Last Updated',
        sortValue: 'updatedAt'
      },
      {
        isHiddenOnXS: true,
        name: 'Created',
        sortValue: 'createdAt'
      },
      {
        isButtonColumn: true
      },
      {
        isButtonColumn: true
      }
    ];
    const newItems = [
      {
        eventKey: 1,
        isFreeUserAtLimit: false,
        itemName: 'Atlas',
        newItemRoute: `${match.url}/new`
      }
    ];
    const trashProps = {
      deletedCount,
      deletedItems: deletedAtlas,
      isTrashOpen,
      closeTrash: this.closeTrash,
      deleteItem: this.handleHardRemove,
      restoreItem: this.handleRestore
    };
    const tablePageHeaderProps = {
      hasSearchInput: true,
      isPremium,
      newItems,
      searching,
      handleSearch
    };
    const tableHeaderRowProps = {
      hasTrash: true,
      sort,
      tableHeaders,
      handleSort,
      openTrash: this.openTrash
    };
    const tableContentProps = {
      duplicateButton: true,
      history,
      hoverItem: () => {},
      isTableEmpty: isEmpty(atlasList),
      itemIdentifier: 'id',
      itemName: 'Atlas',
      items: atlasList,
      loading,
      match,
      numberOfColumns: 6,
      openNewTabButton: true,
      duplicateItem: this.handleDuplicate,
      softDeleteItem: this.handleSoftRemove
    };
    const tablePaginationProps = {
      currentPage,
      itemsPerPage: PER_PAGE,
      totalCount,
      changePage
    };

    if (loading) return <Loading />;
    if (isBasic || isPremium || isAdmin)
      return (
        <TableList
          childProps={{
            trashProps,
            tablePageHeaderProps,
            tableHeaderRowProps,
            tableContentProps,
            tablePaginationProps
          }}
          isFreeUserAtLimit={false}
          isPaginationOn
        />
      );
    return <LoadingFree />;
  }
}

AtlasList.defaultProps = {
  atlasList: [],
  deletedAtlas: [],
  deletedCount: 0,
  loading: true,
  totalCount: 0,
  unfilteredCount: 0
};

AtlasList.propTypes = {
  atlasList: PropTypes.array,
  currentPage: PropTypes.number.isRequired,
  deletedAtlas: PropTypes.array,
  deletedCount: PropTypes.number,
  history: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isPremium: PropTypes.bool.isRequired,
  isBasic: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  match: PropTypes.object.isRequired,
  searching: PropTypes.bool.isRequired,
  sort: PropTypes.object.isRequired,
  totalCount: PropTypes.number,
  unfilteredCount: PropTypes.number,
  changePage: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleSort: PropTypes.func.isRequired
};

export default withRouter(
  withTracker(({ searchValue, currentPage, sort }) => {
    const skip = currentPage * PER_PAGE - PER_PAGE;

    const atlasQuery = { deleted: { $eq: 'no' } };

    const searchRegex = !isEmpty(searchValue) ? new RegExp(searchValue, 'i') : null;
    if (!isNil(searchRegex)) atlasQuery.name = searchRegex;

    const sortOptions = { limit: PER_PAGE, skip, sort };
    const atlasSub = Meteor.subscribe('atlas');

    return {
      atlasList: Atlas.find(atlasQuery, sortOptions).fetch(),
      deletedAtlas: Atlas.find({ deleted: { $ne: 'no' } }).fetch(),
      deletedCount: Atlas.find({ deleted: { $ne: 'no' } }).count(),
      loading: !atlasSub.ready(),
      totalCount: Atlas.find(atlasQuery).count(),
      unfilteredCount: Atlas.find({ deleted: { $eq: 'no' } }).count()
    };
  })(AtlasList)
);
